!(function () {
  'use strict';
  class e {
    constructor(e, t) {
      (this.configuration = {
        expires: null,
        path: '/',
        domain: window.location.hostname,
        sameSite: 'none',
        secure: !0,
      }),
        (this.name = e),
        (this.value = t);
    }
    write() {
      ((-1 !== document.cookie.indexOf('; ') && !document.cookie.split('; ').find((e) => e.startsWith(this.name))) || -1 === document.cookie.indexOf('; ')) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      if (-1 !== document.cookie.indexOf('; ') && document.cookie.split('; ').find((e) => e.startsWith(this.name))) {
        return document.cookie
          .split('; ')
          .find((e) => e.startsWith(this.name))
          .split('=')[1];
      }
      return !1;
    }
    destroy() {
      document.cookie.split('; ').find((e) => e.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
  }
  customElements.get('newsletter-form') ||
    customElements.define(
      'newsletter-form',
      class extends HTMLElement {
        constructor() {
          super(),
            (this.newsletter = this.querySelector('[data-newsletter-form]')),
            (this.sessionStorage = window.sessionStorage),
            (this.popup = this.newsletter.closest('[data-popup]')),
            (this.stopSubmit = !0),
            (this.isChallengePage = !1),
            (this.formID = null),
            this.checkForChallengePage(),
            (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e));
        }
        connectedCallback() {
          this.newsletter.addEventListener('submit', this.newsletterSubmit), this.isChallengePage || this.showMessage();
        }
        newsletterSubmitEvent(e) {
          this.stopSubmit && (e.preventDefault(), this.removeStorage(), this.writeStorage(), (this.stopSubmit = !1), this.newsletter.submit());
        }
        checkForChallengePage() {
          this.isChallengePage = window.location.pathname === theme.routes.root + 'challenge';
        }
        writeStorage() {
          void 0 !== this.sessionStorage && this.sessionStorage.setItem('newsletter_form_id', this.newsletter.id);
        }
        readStorage() {
          void 0 !== this.sessionStorage && (this.formID = this.sessionStorage.getItem('newsletter_form_id'));
        }
        removeStorage() {
          this.sessionStorage?.removeItem('newsletter_form_id');
        }
        showMessage() {
          this.readStorage();
          let focusDelay = 0;
          if (this.newsletter.id === this.formID) {
            const t = document.getElementById(this.formID),
              s = -1 !== window.location.search.indexOf('?customer_posted=true'),
              i = -1 !== window.location.search.indexOf('accepts_marketing');
            if (s) (t.classList.remove('has-error'), t.classList.add('has-success'), this.popup && ((this.cookie = new e(this.popup.dataset.cookieName, 'user_has_closed')), this.cookie.write()));
            else if (i) (t.classList.remove('has-success'), t.classList.add('has-error'));
            if (s || i) {
              const o = visibilityHelper.isElementPartiallyVisible(t) || visibilityHelper.isElementTotallyVisible(t);
              this.scrollToForm(t), i && !o && (focusDelay = 450);
            }
          }
          this.newsletter.classList.contains('has-error') && (this.setErrorAttributes(this.newsletter), this.focusFirstErrorField(this.newsletter, focusDelay));
        }
        setErrorAttributes(e) {
          const t = e.querySelector('.errors');
          if (!t?.id) return;
          let s = e.querySelectorAll('.input-group__field[aria-invalid="true"]');
          if (!s.length) {
            const i = e.querySelector('.input-group__field--email') || e.querySelector('.input-group__field');
            i && (i.setAttribute('aria-invalid', 'true'), i.setAttribute('aria-describedby', t.id));
          } else
            s.forEach((e) => {
              e.getAttribute('aria-describedby') || e.setAttribute('aria-describedby', t.id);
            });
        }
        focusFirstErrorField(e, t = 0) {
          const s = e.querySelector('.input-group__field[aria-invalid="true"]');
          s && (this.popup && (t = Math.max(t, 500)), setTimeout(() => s.focus({preventScroll: !0}), t));
        }
        scrollToForm(e) {
          let {stickyHeaderHeight: t} = window.theme.readHeights();
          const s = t || 0,
            i = e.closest('section'),
            o = e.closest('footer'),
            n = visibilityHelper.isElementPartiallyVisible(e) || visibilityHelper.isElementTotallyVisible(e);
          n ||
            setTimeout(() => {
              let t = window.scrollY,
                n = e.getBoundingClientRect().top;
              i ? (n = i.getBoundingClientRect().top) : o && o.closest('.shopify-section').classList.contains('section-footer--parallax') && ((n = document.body.scrollHeight), (t = 0));
              const r = n - s + t;
              window.scrollTo({top: r, left: 0, behavior: 'smooth'});
            }, 400);
        }
        disconnectedCallback() {
          this.newsletter.removeEventListener('submit', this.newsletterSubmit);
        }
      }
    );
})();
